/**
 * legal.js — riferimenti unici a Termini/Privacy per onboarding e schermate.
 * Quando aggiorni i Termini, alza TOS_VERSION: l'accettazione registrata
 * (locale + server) riporta la versione, così sai chi ha accettato cosa.
 * Alzare TOS_VERSION fa scattare automaticamente il gate di ri-accettazione
 * (vedi components/TosGate.jsx) per chi è già dentro.
 */
import { callFn } from './firebase';

export const TOS_VERSION = '2026-05-31';
export const TOS_ACCEPT_KEY = 'nullum.tosAccepted.v1';

/** Registra localmente l'accettazione dei Termini+Privacy (versione + data). */
export function recordTosAcceptanceLocal() {
  try {
    localStorage.setItem(TOS_ACCEPT_KEY, JSON.stringify({ v: TOS_VERSION, at: Date.now() }));
  } catch { /* storage non disponibile: non bloccante */ }
}

/** True se l'utente ha già accettato la versione CORRENTE dei Termini. */
export function hasAcceptedCurrentTos() {
  try {
    const raw = localStorage.getItem(TOS_ACCEPT_KEY);
    if (!raw) return false;
    return JSON.parse(raw)?.v === TOS_VERSION;
  } catch {
    return false;
  }
}

/**
 * Registra l'accettazione della versione CORRENTE sia in locale sia sul server
 * (prova legale, device-independent). Il locale viene scritto comunque, così
 * il gate si chiude anche se la rete fallisce; il server riprova al giro dopo.
 */
export async function acceptTosRemote() {
  recordTosAcceptanceLocal();
  try {
    await callFn('acceptTos')({ tosVersion: TOS_VERSION });
    return true;
  } catch {
    return false; // locale già registrato: non blocchiamo l'utente
  }
}
